import React from 'react'

import { ReactComponent as DoubleArrowIcon } from '@/assets/svgs/doubleArrow_icon.svg'

import type { CustomButtonProps } from './types'

export default function YearButton({
  type,
  onClick,
  style,
}: CustomButtonProps) {
  return (
    <button
      aria-label={`${type} Year`}
      className={`react-datepicker__navigation 
                react-datepicker__navigation--year 
                react-datepicker__navigation--${type}`}
      onClick={onClick}
      style={style}
      type="button"
    >
      <span
        className={`react-datepicker__navigation-icon react-datepicker__navigation-icon--${type}`}
      >
        <DoubleArrowIcon />
      </span>
    </button>
  )
}
